import { useEffect } from 'react';
import { Routes, Route } from 'react-router';
import PromptProjects from '../components/PromptManagement/prompt';
import { createBrowserRouter } from 'react-router-dom';
import PromptProjectForm from '../components/PromptManagement/aipromptprojectform';

const PromptRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<PromptProjects />} />
      <Route path='/project/:id?' element={<PromptProjectForm />} />
    </Routes>
  );
};
export default PromptRoutes;
